import { render, staticRenderFns } from "./DealReportBySellers.vue?vue&type=template&id=2136c796&"
import script from "./DealReportBySellers.vue?vue&type=script&lang=js&"
export * from "./DealReportBySellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports